import CryptoJS from "crypto-js";
const SECRET_KEY = "zTqGvWOYpPym3Eb0";

let cachedKey = null;

async function getKey() {
  if (cachedKey) return cachedKey;
  cachedKey = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(SECRET_KEY),
    { name: "AES-GCM" },
    false,
    ["decrypt"],
  );
  return cachedKey;
}

export function clearKeyCache() {
  cachedKey = null;
}

export async function decryptData(response) {
  // Already a plain object — bypass routes
  if (response !== null && typeof response === "object") {
    return response?.data || response;
  }

  // Strip surrounding quotes if response is JSON-wrapped string
  const cleaned =
    typeof response === "string"
      ? response.trim().replace(/^"|"$/g, "")
      : response;

  try {
    const combined = Uint8Array.from(atob(cleaned), (c) => c.charCodeAt(0));

    if (combined.length <= 12) {
      throw new Error("Encrypted payload too short");
    }

    const iv = combined.slice(0, 12);
    const ciphertext = combined.slice(12);

    const key = await getKey();

    const decryptedBuffer = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv, tagLength: 128 },
      key,
      ciphertext,
    );

    return JSON.parse(new TextDecoder().decode(decryptedBuffer));
  } catch (e) {
    console.error("decryptData failed:", e.message);
    throw new Error(`Decryption failed: ${e.message}`);
  }
}

// import CryptoJS from "crypto-js";
// const secretKey = "zTqGvWOYpPym3Eb0";

// export function decryptData(encryptedBase64) {
//   return encryptedBase64?.data || encryptedBase64;
//   const key = CryptoJS.enc.Utf8.parse(secretKey);
//   const encryptedHex = CryptoJS.enc.Base64.parse(encryptedBase64);
//   const decrypted = CryptoJS.AES.decrypt({ ciphertext: encryptedHex }, key, {
//     mode: CryptoJS.mode.ECB,
//     padding: CryptoJS.pad.Pkcs7,
//   });
//   let data = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
//   return data;
// }
